import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { withStyles,styled  } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import TextField from '@material-ui/core/TextField';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import PasswordInput from '../components/PasswordInput';
import COLORS from '../resources/colors/ColorsApp';
import Loader from '../components/Loader';
import {isEmpty, isMail} from '../../config/helpers/Validations';
import DeleteIcon from '@material-ui/icons/Delete';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import KeyboardVoiceIcon from '@material-ui/icons/KeyboardVoice';
import SendIcon from '@material-ui/icons/SearchRounded';
import TodayIcon from '@material-ui/icons/Today';
import AddIcon from '@material-ui/icons/Add';
import InputBase from '@material-ui/core/InputBase';
import Font, { Text } from 'react-font'
import {Modal} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AccountCircleRoundedIcon from '@material-ui/icons/AccountCircleRounded';
import Grid from '@material-ui/core/Grid';
import styles2 from './CardLogin2.css';
import 'animate.css';
import fondo from './fondo.png'; // Asegúrate de que el nombre y la ruta sean correctos
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Tooltip from '@material-ui/core/Tooltip';

import DatosPersona from './DatosPersona';
import DatosPersona2 from './DatosPersona2';
import { GetCitasDisponibles } from '../../services/SecurityService';





const CssTextField = styled(TextField)({
  "& .MuiInputBase-input":{
    color:'white',width:'100%',
    backgroundColor: '#BB1A41',
    borderRadius:5,margin:1
      
  },
 '& label.Mui-focused': {
    color: 'green',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'red',
     color:'white',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'white',
    
    },
   
    '&:hover fieldset': {
      borderColor: '#ffcb72',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#D7B882',
    },
  },
  
});

const CModal = styled(Modal)`
  position: fixed;
  width: 400px;
  z-index: 1040;
  border: 1px solid #e5e5e5;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  padding: 20px;
`;

const ColorButton = styled(Button)(({ theme }) => ({
  color: 'white',
  borderColor: 'white',
  backgroundColor:'#BB1A41',
  '&:hover': {
    backgroundColor: '#00AD1F',
    color:'white',
    borderColor: '#00AD1F',
  },
}));



class CardLogin2 extends Component {

  constructor(props){
    super(props);

    this.afterSubmit = this.afterSubmit.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.keyPress = this.keyPress.bind(this);

    

    this.state = {
      email: '',
      password: '',
      errEmail: '',
      errPassword: '',
      loading: false,
      modal:false,
      modal2:false,
      modal3:false,

      correo:'',
      telefono:'',
      contraseña:'',
      usuarioR:''
    };
  }



  componentDidMount() {
    // Código de Google Tag Manager
console.log('Citas Cartillas')
window.dataLayer = window.dataLayer || [];
function gtag(){window.dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', 'G-CECPD85V6P');
  }

  handleEmailChange = evt => {
    this.setState({ email: evt.target.value });
  };

  handlePasswordChange = evt => {
    this.setState({ password: evt.target.value });
  };
  handleSubmit = () => {
    const { email, password } = this.state;
    alert(`Signed up with email: ${email} password: ${password}`);
  };
  afterSubmit(){
    this.setState({loading: false});
  }

  validateForm(){
    let valid=true, errEmail="", errPassword="";
    if(isEmpty(this.state.email)){
      errEmail = "Campo de Usuario, esta vacío";
      valid=false;
    }

    if(isEmpty(this.state.password)){
      errPassword = "Campo de Contraseña, esta vacío";
      valid=false;
    }
    if(!valid){
      this.setState({errEmail: errEmail, errPassword: errPassword});
    }
    return valid;
  }


  keyPress(e){
    if(e.key == 'Enter'){
    

       e.preventDefault();
       if(this.validateForm()){
         this.setState({loading: true});
         this.props.onSubmit(this.state.email, this.state.password, this.afterSubmit)
       }
    }
 }

  render(){
  const { classes, onSubmit } = this.props;
  const { email, password } = this.state;
  const isEnabled = email.length > 0 && password.length > 0;


  return (
    
    <div className='miTexto'>
       <script async src="https://www.googletagmanager.com/gtag/js?id=G-CECPD85V6P"></script>
      
      <form className={classes.container}onSubmit={this.handleSubmit}>

        
        
      <nav style={{ backgroundColor: "#791938" }} className="navbar navbar-expand-lg">
  <div className="container">
    <a className="navbar-brand" href="#">
      <img
        src={require("./logo-ayuntamiento.png")}
        className="d-block mx-lg-auto img-fluid"
        alt="Bootstrap Themes"
        width="80%"
      />
    </a>
    <button
      className="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <a style={{ color: "white",fontFamily: 'Montserrat',padding: "10px 25px" }} className="nav-link active" href="">
            INICIO
          </a>
        </li>
        <li className="nav-item">
          <a style={{ color: "white",fontFamily: 'Montserrat',padding: "10px 25px" }} className="nav-link active" href="https://www.tepic.gob.mx/">
            AYUNTAMIENTO DE TEPIC
          </a>
        </li>

       {/* 
        <li className="nav-item dropdown">
          <a
            style={{ color: "white",fontFamily: 'Montserrat' }}
            className="nav-link dropdown-toggle"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            MI GOBIERNO
          </a>
          <ul  className="dropdown-menu">
            <li>
              <a style={{fontFamily: 'Montserrat' }} className="dropdown-item" href="https://www.tepic.gob.mx/cabildo.html">CABILDO</a>
            </li>
            <li>
              <a style={{ fontFamily: 'Montserrat' }} className="dropdown-item" href="https://www.tepic.gob.mx/gabinete.html">GABINETE</a>
            </li>
            <li>
              <a style={{ fontFamily: 'Montserrat' }} className="dropdown-item" href="https://www.tepic.gob.mx/dependencias.html">DEPENDENCIAS</a>
            </li>
            <li>
              <a style={{ fontFamily: 'Montserrat' }} className="dropdown-item" href="https://www.tepic.gob.mx/comisiones.html">COMISIONES</a>
            </li>
            
            <li>
              <a style={{ fontFamily: 'Montserrat' }} className="dropdown-item" href="https://www.tepic.gob.mx/sesiones-de-cabildo/">SESIONES DE CABILDO</a>
            </li>
            <li>
              <a style={{ fontFamily: 'Montserrat' }} className="dropdown-item" href="https://www.tepic.gob.mx/compilacion-normativa/">COMPILACION NORMATIVA</a>
            </li>
          </ul>
        </li>

        */}
         {/* 
        <li className="nav-item">
          <a style={{ color: "white",fontFamily: 'Montserrat' }} className="nav-link" href="https://www.tepic.gob.mx/tramites-y-servicios/">
            TRÁMITES
          </a>
        </li>
*/}
 {/* 
        <li className="nav-item dropdown">
          <a
            style={{ color: "white",fontFamily: 'Montserrat' }}
            className="nav-link dropdown-toggle"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
           COMUNICACIÓN
          </a>
          <ul  className="dropdown-menu">
            <li>
              <a style={{ fontFamily: 'Montserrat' }}  className="dropdown-item" href="#">GACETA OFICIAL HISTÓRICO</a>
            </li>
            <li>
              <a style={{ fontFamily: 'Montserrat' }} className="dropdown-item" href="https://www.tepic.gob.mx/gacetas-extraordinarias/">· GACETAS XLII</a>
            </li>
            <li>
              <a style={{ fontFamily: 'Montserrat' }} className="dropdown-item" href="https://www.tepic.gob.mx/gaceta-oficial/">· GACETAS ORDINARIAS XLI</a>
            </li>
            <li>
              <a style={{ fontFamily: 'Montserrat' }} className="dropdown-item" href="https://www.tepic.gob.mx/gacetas-extraordinarias-historico/">· GACETAS EXTRAORDINARIAS XLI</a>
            </li>
            
           
          </ul>
        </li>
*/}

        <li className="nav-item">
          <a style={{ color: "white",fontFamily: 'Montserrat',padding: "10px 25px" }}  className="nav-link" href="https://transparencia.tepic.gob.mx/">
            TRANSPARENCIA
          </a>
        </li>
         {/* 
        <li className="nav-item">
          <a style={{ color: "white",fontFamily: 'Montserrat' }}  className="nav-link" href="https://www.tepic.gob.mx/sala-de-prensa/">
            NOTICIAS
          </a>
        </li>
        */}
      </ul>
    </div>
  </div>
</nav>


<nav
  style={{
    backgroundColor: "#C0934C",
    boxShadow: "0px 15px 25px rgba(0, 0, 0, 0.5)", // Sombra más grande y menos oscura
    
  }}
  className="navbar navbar-expand-lg"
>
  <div className="container">
  <div>
      {/* Estilos responsivos dentro del mismo componente */}
      <style dangerouslySetInnerHTML={{ __html: `
        .responsive-link {
          color: white;
          margin-left: 25px;
          font-family: 'Montserrat';
          font-size: 16px;
        }

        @media (max-width: 768px) {
          .responsive-link {
            font-size: 14px !important; /* Tamaño más pequeño en móviles */
          }
        }
      ` }} />

      <a style={{fontFamily: 'Montserrat' }} className="navbar-brand responsive-link" href="#">
        Ayuntamiento | Mi Gobierno | <span style={{ fontWeight: 'bold' }}>Cartilla Militar Nacional</span>
      </a>
    </div>

    {/* Contenedor para las imágenes */}
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end', // Alinea las imágenes a la derecha
        gap: '15px', // Espacio entre las imágenes
        alignItems: 'center', // Alinea las imágenes verticalmente
      }}
    >
      <a href="tel:+523112652791"><Tooltip title="TELEFONO" placement="top">
                       
                        
        <img src={require('./telefono.png')} className="img-fluid" alt="Telefono" width="25" loading="lazy" />
        </Tooltip>
      </a>
      <a href="https://wa.me/523112652791"><Tooltip title="WHATSAPP" placement="top">
        <img src={require('./whatsapp.png')} className="img-fluid" alt="Whatsapp" width="25" loading="lazy" />
        </Tooltip>
      </a>
      <a href="mailto: hola@tepic.gob.mx"><Tooltip title="CORREO" placement="top">
        <img src={require('./correo.png')} className="img-fluid" alt="Correo" width="25" loading="lazy" />
        </Tooltip>
      </a>
      <a href="https://www.facebook.com/GobTepic/"><Tooltip title="FACEBOOK" placement="top">
        <img src={require('./facebook.png')} className="img-fluid" alt="Facebook" width="25" loading="lazy" />
        </Tooltip>
      </a>
      <a href="http://radio.tepic.gob.mx/"><Tooltip title="RADIO" placement="top">
        <img src={require('./radio.png')} className="img-fluid" alt="Radio" width="25" loading="lazy" />
        </Tooltip>
      </a>
    </div>
  </div>
</nav>




  <div>
  <img src={require('./banner.png')} class="d-block mx-lg-auto img-fluid" alt="Bootstrap Themes" width="100%" loading="lazy" />
     
    </div>
   
    <div style={{
    backgroundImage: `url(${fondo})`, // Usar la variable importada
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    width: '100%',
    height: '300px', // Usa el 100% de la altura visible de la ventana
    display: 'flex',
    flexDirection: 'column', // Coloca el texto y los botones en columna
    justifyContent: 'flex-start', // Deja el texto en la parte superior
    alignItems: 'center', // Centra todo el contenido horizontalmente
    color: 'black',
    textAlign: 'center',
    padding: '20px',
    fontFamily: 'Montserrat',
    fontSize: '38px',
    borderBottom: '15px solid #c49a47', // Agrega el borde inferior amarillo de 5px

  }}>
     <div>
      {/* Estilos responsivos dentro del mismo componente */}
      <style dangerouslySetInnerHTML={{ __html: `
        .responsive-text {
          font-size: 32px; /* Tamaño predeterminado */
        }

        @media (max-width: 768px) {
          .responsive-text {
            font-size: 16px !important; /* Tamaño más pequeño en móviles */
            margin-top: 20px;
          }
        }
      ` }} />
      
      <h1 className="responsive-text" style={{ color: 'white', marginTop: '32px', fontFamily: 'Bogue' }}>
        Si requieres de una cita, regístrala o si tienes un documento <br />
        en trámite, puedes consultarlo.
      </h1>
    </div>

    {/* Renglón de botones */}
    <div style={{
      display: 'flex',
      justifyContent: 'center', // Centra los botones horizontalmente
      gap: '20px', // Espacio entre los botones
      marginTop: '20px', // Separación entre el texto y los botones
    }}>
       <ColorButton disabled={!isEnabled}
            variant="contained"
              disabled={this.state.loading}
              style={{fontSize:'18px',fontWeight: "bold", backgroundColor: "#C0934C", borderRadius:5,textTransform:'none'}}
              onClick={(event)=> {
             this.setState({modal:true})


           
      
              }}><TodayIcon className={classes.extendedIcon} />&nbsp;Registrar cita 
              </ColorButton>

              <ColorButton disabled={!isEnabled}
      variant="contained"
        disabled={this.state.loading}
        style={{fontSize:'18px',fontWeight: "bold", backgroundColor: "#C0934C", borderRadius:5,textTransform:'none'}}
        onClick={(event)=> {
       this.setState({modal2:true})
        }}> <SendIcon className={classes.extendedIcon} />&nbsp;Consultar trámite 
       </ColorButton>
    </div>
</div>

  
  
     
   <div style={{}}>
<div class="container col-xxl-8 px-4 py-4" style={{backgroundColor:'transparent'}}>
    <div class="row flex-lg-row-reverse align-items-center g-5 py-5">
      
     

    <div className="container mt-4">
      <div className="accordion" id="accordionExample">
        {/* Acordeón 1 */}
        <div className="accordion-item" style={{ border: 'none' }}>
          <h2 style={{color:'#751338', fontSize:'18px'}} className="accordion-header" id="headingOne">
            <button
              className="accordion-button collapsed" // Establece el acordeón como cerrado por defecto
              style={{
                border: 'none', // Elimina el borde del botón
                boxShadow: 'none', // Elimina el borde azul de enfoque
                outline: 'none', // Elimina el contorno al seleccionar
                backgroundColor: '#fff', // Fondo blanco
                color:'#751338', fontSize:'28px', fontWeight:'bold',
                display: 'flex',
                alignItems: 'center', // Centra los elementos verticalmente
                paddingLeft: '0', // Elimina el padding izquierdo predeterminado de Bootstrap
                paddingRight: '0', // Elimina el padding derecho predeterminado de Bootstrap
              }}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="false" // El primer acordeón estará cerrado por defecto
              aria-controls="collapseOne"
            >
              {/* Icono de la flecha (amarilla) a la izquierda */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="#c49a47" // Color de la flecha amarilla
                className="bi bi-caret-down-fill"
                viewBox="0 0 16 16"
                style={{ marginRight: '10px' }} // Espaciado entre la flecha y el texto
              >
                <path d="M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
              </svg>

              Cartilla de Servicio Militar Nacional
            </button>
          </h2>
          <div
            id="collapseOne"
            className="accordion-collapse collapse" // Asegura que no esté expandido
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
            style={{ border: 'none' }} // Elimina el borde del div de contenido
          >
            <div
  style={{
    fontSize: '20px',
    color: '#000000CC',
    textAlign: 'justify',
  }}
  className="accordion-body"
>
  La Cartilla del Servicio Militar Nacional (CSMN) es un documento de
  identificación militar expedida a los mexicanos en edad militar. El Artículo
  1º de la Ley del Servicio Militar Nacional (LSMN) declara obligatorio y de
  orden público el servicio de las armas para todos los mexicanos por
  nacimiento o naturalización, entre los 18 y 40 años de edad, existiendo la
  posibilidad de efectuarlo en el extranjero. El artículo 11 del citado
  ordenamiento determina que todos los mexicanos de edad militar tienen la
  obligación de inscribirse en las juntas municipales o en las oficinas
  consulares de México, en su calidad de auxiliares de las autoridades de la
  Secretaría de la Defensa Nacional (SEDENA), de conformidad con los artículos
  34 y 43 de la LSMN. Los mexicanos cuya edad se encuentra en el rango de 18 a
  38 años y que residen en el exterior deberán acudir a las Oficinas Consulares
  de México a inscribirse para cumplir con sus deberes militares del 2 de enero
  al 31 de diciembre de cada año y comprobar documentalmente que residirán por
  lo menos un año en el exterior.
</div>

          </div>
        </div>

        {/* Acordeón 2 */}
        <div className="accordion-item" style={{ border: 'none' }}>
          <h2 className="accordion-header" id="headingTwo">
            <button
              className="accordion-button collapsed" // Establece el acordeón como cerrado por defecto
              style={{
                border: 'none', // Elimina el borde del botón
                boxShadow: 'none', // Elimina el borde azul de enfoque
                outline: 'none', // Elimina el contorno al seleccionar
                backgroundColor: '#fff', // Fondo blanco
                color:'#751338', fontSize:'28px', fontWeight:'bold',
                display: 'flex',
                alignItems: 'center', // Centra los elementos verticalmente
                paddingLeft: '0', // Elimina el padding izquierdo predeterminado de Bootstrap
                paddingRight: '0', // Elimina el padding derecho predeterminado de Bootstrap
              }}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false" // El segundo acordeón estará cerrado por defecto
              aria-controls="collapseTwo"
            >
              {/* Icono de la flecha (amarilla) a la izquierda */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="#c49a47" // Color de la flecha amarilla
                className="bi bi-caret-down-fill"
                viewBox="0 0 16 16"
                style={{ marginRight: '10px' }} // Espaciado entre la flecha y el texto
              >
                <path d="M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
              </svg>

              Requisitos
            </button>
          </h2>
          <div
            id="collapseTwo"
            className="accordion-collapse collapse" // Asegura que no esté expandido
            aria-labelledby="headingTwo"
            data-bs-parent="#accordionExample"
            style={{ border: 'none' }} // Elimina el borde del div de contenido
          >
            <div
  style={{
    fontSize: '20px',
    color: '#000000CC',
    textAlign: 'justify',
  }}
  className="accordion-body"
>
  <strong>ALISTAMIENTO PARA OBTENER LA CARTILLA E IDENTIDAD DEL SERVICIO MILITAR NACIONAL, “CLASE 2008” Y REMISOS.</strong>
  <br />
  <br />
  • Acta de Nacimiento Original y copia, vigente no menor a tres años, con los datos legibles y correctos, sin tachaduras, enmendaduras o alteraciones.
  <br />
  <br />
  • 4 FOTOGRAFÍAS DE ESTUDIO, no digitales, tamaño credencial de (35X45MM), en blanco y negro, papel mate con fondo blanco y sin retoque, recientes, de frente y orejas completamente despejadas, sin melena, sin patillas, sin barba, bigote recortado a la altura del borde del labio inferior. Sin lentes, ni cadena, ni aretes. Del nacimiento del pelo a la punta de la barbilla tendrá 21 mm. (Peinado no moderno).
  <br />
  <br />
  <strong>UNA COPIA DE LO SIGUIENTE:</strong>
  <ul>
    <li>Comprobante de domicilio reciente (luz, agua o teléfono).</li>
    <li>Certificado máximo grado de estudios.</li>
    <li>CURP (Formato Nuevo).</li>
    <li>Credencial del INE (en caso de no contar con ella, presentar copia del comprobante del registro en el INE, o copia del INE de los padres).</li>
  </ul>
  <strong>PERSONAL REMISO</strong>
  <br />
  Aquel que no obtuvo su cartilla al cumplir 18 años de edad, deberá presentar una constancia de No Registro, emitida por la Junta Municipal de Reclutamiento del lugar donde nació, en la que se especifique que no se le ha expedido cartilla de identidad del Servicio Militar Nacional, solo en caso de haber nacido en otro municipio o estado.
  <br />
  <br />
  <strong>IMPORTANTE:</strong>
  <ol>
    <li>Tener entre 18 y 39 años de edad.</li>
    <li>No haberla tramitado anteriormente en ningún lugar.</li>
    <li>Al ser un trámite que requiere la firma y la toma de una huella dactilar del interesado, no es posible que otra persona lo efectúe en su lugar.</li>
    <li>El domicilio debe coincidir en la credencial del INE y en el comprobante de domicilio.</li>
  </ol>
</div>

          </div>
        </div>

        {/* Acordeón 3 */}
        <div className="accordion-item" style={{ border: 'none' }}>
          <h2 className="accordion-header" id="headingThree">
            <button
              className="accordion-button collapsed" // Establece el acordeón como cerrado por defecto
              style={{
                border: 'none', // Elimina el borde del botón
                boxShadow: 'none', // Elimina el borde azul de enfoque
                outline: 'none', // Elimina el contorno al seleccionar
                backgroundColor: '#fff', // Fondo blanco
                color:'#751338', fontSize:'28px', fontWeight:'bold',
                display: 'flex',
                alignItems: 'center', // Centra los elementos verticalmente
                paddingLeft: '0', // Elimina el padding izquierdo predeterminado de Bootstrap
                paddingRight: '0', // Elimina el padding derecho predeterminado de Bootstrap
              }}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false" // El tercer acordeón estará cerrado por defecto
              aria-controls="collapseThree"
            >
              {/* Icono de la flecha (amarilla) a la izquierda */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="#c49a47" // Color de la flecha amarilla
                className="bi bi-caret-down-fill"
                viewBox="0 0 16 16"
                style={{ marginRight: '10px' }} // Espaciado entre la flecha y el texto
              >
                <path d="M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
              </svg>

              Ubicación
            </button>
          </h2>
          <div
            id="collapseThree"
            className="accordion-collapse collapse" // Asegura que no esté expandido
            aria-labelledby="headingThree"
            data-bs-parent="#accordionExample"
            style={{ border: 'none' }} // Elimina el borde del div de contenido
          >
            <div
  style={{
    fontSize: '20px',
    color: '#000000CC',
    textAlign: 'justify',
  }}
  className="accordion-body"
>
  Lunes a viernes de 9:00 a 14:30 horas, MERCADO MORELOS. 2°. Piso. Calle
  Emiliano Zapata Poniente Centro.
  <br />  <br />
  Del 15 de enero al 15 de octubre 2026.
</div>

          </div>
        </div>



         {/* Acordeón 4 */}
         <div className="accordion-item" style={{ border: 'none' }}>
          <h2 className="accordion-header" id="headingFour">
            <button
              className="accordion-button collapsed" // Establece el acordeón como cerrado por defecto
              style={{
                border: 'none', // Elimina el borde del botón
                boxShadow: 'none', // Elimina el borde azul de enfoque
                outline: 'none', // Elimina el contorno al seleccionar
                backgroundColor: '#fff', // Fondo blanco
                color:'#751338', fontSize:'28px', fontWeight:'bold',
                display: 'flex',
                alignItems: 'center', // Centra los elementos verticalmente
                paddingLeft: '0', // Elimina el padding izquierdo predeterminado de Bootstrap
                paddingRight: '0', // Elimina el padding derecho predeterminado de Bootstrap
              }}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false" // El tercer acordeón estará cerrado por defecto
              aria-controls="collapseFour"
            >
              {/* Icono de la flecha (amarilla) a la izquierda */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="#c49a47" // Color de la flecha amarilla
                className="bi bi-caret-down-fill"
                viewBox="0 0 16 16"
                style={{ marginRight: '10px' }} // Espaciado entre la flecha y el texto
              >
                <path d="M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
              </svg>

              Fundamento Jurídico
            </button>
          </h2>
          <div
            id="collapseFour"
            className="accordion-collapse collapse" // Asegura que no esté expandido
            aria-labelledby="headingFour"
            data-bs-parent="#accordionExample"
            style={{ border: 'none' }} // Elimina el borde del div de contenido
          >
            <div
  style={{
    fontSize: '20px',
    color: '#000000CC',
    textAlign: 'justify',
  }}
  className="accordion-body"
>
  El Servicio Militar Nacional (SMN) en México está fundamentado en el artículo
  5 de la Constitución Política de los Estados Unidos Mexicanos. Este artículo
  establece que el servicio militar es obligatorio para todos los mexicanos por
  nacimiento o naturalización.  
  <br />
  <br />
  El SMN también está respaldado por otras leyes y reglamentos, como:  
  <ul>
    <li>La Ley Orgánica de la Administración Pública Federal</li>
    <li>La Ley Orgánica del Ejército y Fuerza Aérea</li>
    <li>El Reglamento Interior de la Secretaría de la Defensa Nacional (SEDENA)</li>
    <li>El Reglamento de la Ley del Servicio Militar</li>
  </ul>
  El SMN se implementó para incrementar los efectivos de las fuerzas armadas y
  hacer frente a posibles agresiones.
</div>

          </div>
        </div>
      </div>
    </div>



     
    </div>
 </div>
  </div>
</form>
   
  
   

     
      <Modal 
               size="lg"
               centered
          
              show={this.state.modal} onHide={()=>this.setState({
               modal:false 
              })}>
 
                <Modal.Body>
               
               
                <DatosPersona id_usuario={2} actArr={()=>console.log("Registro")} handleClose={()=>this.setState({modal:false})}/>

               
              
                </Modal.Body>
                
              </Modal>

              <Modal style={{borderRadius:'2rem'}}
               size="lg"
               centered
          
              show={this.state.modal2} onHide={()=>this.setState({
               modal2:false 
              })}>
 
                <Modal.Body style={{borderRadius:'2rem'}}>
               
               
                <DatosPersona2 id_usuario={2} actArr={()=>console.log("Registro")} handleClose={()=>this.setState({modal2:false})}/>

               
              
                </Modal.Body>
                
              </Modal>

              <div>
  <img src={require('./textura-footer.png')} class="d-block mx-lg-auto img-fluid" alt="Bootstrap Themes" width="100%"  loading="lazy" />
     
    </div>
              <footer style={{ backgroundColor: '#72153B', color: '#fff', padding: '20px 0', marginTop:'15px' }}>
      <div className="container">
        <div className="row">
          {/* Columna 1 */}
          <div className="col-md-3 text-center">
          <img src={require('./logo-tepic-blanco@2x.png')} className="img-fluid" alt="Logo Tepic" width="100" loading="lazy" />
          </div>

          {/* Columna 2 */}
          <div style={{borderLeft:'2px solid #FFFFFF'}} className="col-md-3 text-center">
            <h5 style={{fontFamily: 'Montserrat',fontWeight:'bold' }}>AYUNTAMIENTO DE TEPIC</h5>
            <ul className="list-unstyled">
              <li><a href="#" style={{ color: '#fff', textDecoration: 'none',fontFamily: 'Montserrat' }}>Puebla No. 218 Norte</a></li>
              <li><a href="#" style={{ color: '#fff', textDecoration: 'none',fontFamily: 'Montserrat' }}>Colonia Centro, C.P. 63000</a></li>
              <li><a href="#" style={{ color: '#fff', textDecoration: 'none',fontFamily: 'Montserrat' }}>Tepic, Nayarit, México</a></li>
            </ul>
          </div>

          {/* Columna 3 */}
          <div style={{borderLeft:'2px solid #FFFFFF'}} className="col-md-3 text-center">
            <h5 style={{fontFamily: 'Montserrat',fontWeight:'bold' }}>DENUNCIAS</h5>
            <ul className="list-unstyled">
              <li><a href="tel:+123456789" style={{ color: '#fff', textDecoration: 'none',fontFamily: 'Montserrat' }}>311-265-27-91</a></li>
            </ul>
            <h5 style={{fontFamily: 'Montserrat',fontWeight:'bold' }}>EMERGENCIAS</h5>
            <ul className="list-unstyled">
              <li><a href="tel:+123456789" style={{ color: '#fff', textDecoration: 'none',fontFamily: 'Montserrat' }}>911</a></li>
            </ul>
          </div>

          {/* Columna 4 */}
          <div style={{borderLeft:'2px solid #FFFFFF'}} className="col-md-3 d-flex justify-content-center align-items-center">
            <a href='https://www.facebook.com/GobTepic/'>
  <img src={require('./facebook@2x.png')} className="img-fluid" alt="Logo Facebook" width="60" loading="lazy" />
  </a>
</div>

        </div>

        {/* Nuevo renglón con 3 columnas */}
       
      </div>

      

    </footer>
    
    <footer style={{ backgroundColor:'#5E0D32', color: '#fff', padding: '20px 0' }}>
      <div className="container">
        <div className="row">
         

          {/* Columna 2 */}
          <div className="col-md-4 text-center">
  <a
    href="https://www.tepic.gob.mx/wp-content/uploads/2024/10/Aviso_Integral.pdf"
    style={{ textDecoration: 'none', color: '#C89211' }} // Elimina el subrayado y cambia el color
  >
    <h5 style={{ color: '#C89211', fontSize: '18px',fontFamily: 'Montserrat' }}>
      AVISO DE PRIVACIDAD INTEGRAL 
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="#c49a47" // Color de la flecha amarilla
        className="bi bi-caret-down-fill"
        viewBox="0 0 16 16"
        style={{ marginRight: '10px' }} // Espaciado entre la flecha y el texto
      >
        <path d="M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
      </svg> 
    </h5>
  </a>
</div>


          {/* Columna 3 */}
          <div className="col-md-4 text-center">
          <a
    href="https://www.tepic.gob.mx/wp-content/uploads/2024/10/Aviso_Simplificado.pdf"
    style={{ textDecoration: 'none', color: '#C89211' }} // Elimina el subrayado y cambia el color
  >
            <h5 style={{color:'#C89211',fontSize:'18px',fontFamily: 'Montserrat'}}>AVISO DE PRIVACIDAD SIMPLIFICADO<svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="#c49a47" // Color de la flecha amarilla
                className="bi bi-caret-down-fill"
                viewBox="0 0 16 16"
                style={{ marginRight: '10px' }} // Espaciado entre la flecha y el texto
              >
                <path d="M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
              </svg></h5>
              </a>
           
          </div>

          {/* Columna 4 */}
          <div className="col-md-4 text-center">
          <a
    href="https://www.tepic.gob.mx/wp-content/uploads/2024/10/Documento_ARCOP.pdf"
    style={{ textDecoration: 'none', color: '#C89211' }} // Elimina el subrayado y cambia el color
  >
            <h5 style={{color:'#C89211',fontSize:'18px',fontFamily: 'Montserrat'}}>FORMATO DERECHOS DE ARCO<svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="#c49a47" // Color de la flecha amarilla
                className="bi bi-caret-down-fill"
                viewBox="0 0 16 16"
                style={{ marginRight: '10px' }} // Espaciado entre la flecha y el texto
              >
                <path d="M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
              </svg></h5>
              </a>
          </div>
        </div>

        {/* Nuevo renglón con 3 columnas */}
       
      </div>


    </footer>



    

           
          
              </div>

              



    
  );
  }
}

const styles = {
 
};

CardLogin2.propTypes = {
  classes: PropTypes.object.isRequired,
  onSubmit: PropTypes.func
};

export default withStyles(styles)(CardLogin2);